import { StorageService, StorageType, ToasterService } from '@anddone/ui-utilities';
import { Injectable, inject } from '@angular/core';
import { AbstractControl, ValidationErrors } from '@angular/forms';
import moment from 'moment';
import { BehaviorSubject } from 'rxjs';
import { Clipboard } from '@angular/cdk/clipboard';

@Injectable({
  providedIn: 'root',
})
export class AllyCommonService {
  private isLoaderSubject = new BehaviorSubject<boolean>(false);
  private clearFilter = new BehaviorSubject<boolean>(false);
  private countryList: any[] = [];
  private stateList: any[] = [];

  private storageService = inject(StorageService);
  private clipboard = inject(Clipboard);
  private toasterService = inject(ToasterService);

  // Getter for the isLoader property
  getIsLoader() {
    return this.isLoaderSubject.asObservable(); // Expose as observable
  }

  // Setter for the isLoader property
  setIsLoader(value: boolean) {
    this.isLoaderSubject.next(value); // Update the loader state
  }
  // Getter for the isLoader property
  getClearFilter() {
    return this.clearFilter.asObservable(); // Expose as observable
  }

  // Setter for the isLoader property
  setClearFilter(value: boolean) {
    this.clearFilter.next(value); // Update the loader state
  }

  getLoggedInData() {
    return JSON.parse(this.storageService.get(StorageType.Session, 'userDetails') ?? '{}');
  }

  setCountryList(data: any[]): void {
    this.countryList = data || [];
  }

  getCountryList(): any[] {
    return this.countryList;
  }

  setStateList(data: any[]): void {
    this.stateList = data || [];
  }

  getStateList(): any[] {
    return this.stateList;
  }

  getNonDefaultLoggedInData() {
    return JSON.parse(this.storageService.get(StorageType.Session, 'nonDefaultAdminUser') ?? '{}');
  }

  /**
   * @param date
   * @returns number of days difference between current date and input date
   */
  calculateDateDiff(date: any) {
    if (date) {
      const inputDate: any = new Date(date);
      const currentDate: any = new Date();
      const diffDays: any = Math.floor((currentDate - inputDate) / (1000 * 60 * 60 * 24));
      return diffDays;
    } else {
      return 0;
    }
  }

  // get formatted date
  getFormattedDate(date: any) {
    if (date) {
      return moment(date).format('MM-DD-YYYY');
    } else {
      return 0;
    }
  }

  copyValueToClipboard(valueToCopy: string) {
    this.clipboard.copy(valueToCopy);
    this.toasterService.showInfo('Copied to clipboard', 'full');
  }
}

// Custom validator for matching passwords
export class PasswordValidation {
  static matchPassword(control: AbstractControl): ValidationErrors | null {
    const passwordControl = control.get('newPassword');
    const confirmPasswordControl = control.get('confirmPassword');
    const password = passwordControl?.value ?? '';
    const confirmPassword = confirmPasswordControl?.value ?? '';

    // Blank check
    if (confirmPassword.trim() === '') {
      confirmPasswordControl?.setErrors({
        ...confirmPasswordControl.errors,
        blankPassword: true,
      });
      return { blankPassword: true };
    }

    // Match check
    if (password !== confirmPassword) {
      confirmPasswordControl?.setErrors({
        ...confirmPasswordControl.errors,
        matchPassword: true,
      });
      return { matchPassword: true };
    }

    // Clear errors if valid
    confirmPasswordControl?.setErrors(null);
    return null;
  }
}
